import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseIncomeDefaultValues } from './baseIncome';

export const getSecondaryEmploymentDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseIncomeDefaultValues(attribution),
    beginnDerTaetigkeit: null,
});
